<template>
  <div id="wrapper">
    <div id="page-wrapper" class="gray-bg">

      <nav role="navigation" class="navbar navbar-fixed-top">
        <div class="navbar-header">
          <router-link :to="{ name: 'dashboard' }" class="navbar-minimalize minimalize-styl-2 btn btn-primary">
            <i class="fa fa-sign-in"></i> Go to Dashboard
          </router-link>
        </div>
      </nav>
      <div class="wrapper border-bottom white-bg page-heading">
        <div class="container">
          <div class="row">
            <div class="margin-80"></div>
            <div class="col-sm-7 col-lg-7">
              <img class="payment-logo" src="/static/Payment Logo.png" alt="Arrow Logistics">
            </div>
            <div class="col-sm-5 col-lg-5">
              <p class="invoice-due complete">RECIPIENT CREATED TAX INVOICE</p>
              <h1 class="text-right xero-number">{{ paymentDecorated.xero_number }}</h1>
            </div>
          </div><!-- /.row -->
        </div>
      </div>

      <div class="wrapper wrapper-content">
        <ul class="nav nav-actions">
          <li><a :href="downloadPdfUrl"><i class="fa fa-file-pdf-o"></i> Download PDF</a></li>
        </ul>
        <div class="details-flex">
          <div class="ibox ibox-flex">
            <div class="ibox-content ibox-content-padding-xs">
              <ul class="invoice-details">
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">To:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>
                      {{ paymentDecorated.carrier_name }}<br />
                      {{ paymentDecorated.carrier_address }}<br />
                      {{ paymentDecorated.carrier_suburb }}, {{ paymentDecorated.carrier_state }}, {{ paymentDecorated.carrier_postcode }},<br />
                      Australia
                    </p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Payment:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ paymentDecorated.xero_number }}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Reference:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ paymentDecorated.carrier_abn}}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Issued:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ paymentDecorated.created_date_alternative }}</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Paid On:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>{{ paymentDecorated.paid_date_alternative }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="ibox ibox-flex">
            <div class="ibox-content ibox-content-padding-xs">
              <ul class="invoice-details">
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">From:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>
                      Arrow Logistics (QLD) Pty Ltd<br />
                      ATF Forster &amp; Borrman Trust<br />
                      PO Box 4796<br />
                      Toowoomba East QLD 4350<br />
                    </p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">ACN:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>119 008 454</p>
                  </div>
                </li>
                <li class="row">
                  <div class="col-sm-5 col-md-4">
                    <p class="heading">Office:</p>
                  </div>
                  <div class="col-sm-7 col-md-8">
                    <p>0455 123 172</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content ibox-content-padding-xs">
            <h3 class="invoice-single">Payment Items</h3>

            <ul class="list-detail list-detail-invoice-single">
              <payment-item v-for="(item, index) in items" :key="index" :item="item" :disable-link="true"></payment-item>
            </ul>

            <div class="row">
              <div class="col-xs-offset-3 col-xs-9 col-sm-offset-7 col-sm-5 col-lg-offset-8 col-lg-4">
                <ul class="invoice-totals">
                  <li>
                    Subtotal
                    <span class="amount">{{ paymentDecorated.total_without_gst }}</span>
                  </li>
                  <li>
                    Total GST (10%)
                    <span class="amount">{{ paymentDecorated.total_gst }}</span>
                  </li>
                  <li class="total">
                    Total AUD
                    <span class="amount">{{ paymentDecorated.total_with_gst }}</span>
                  </li>
                  <li v-if="paymentDecorated.hasSomePayments">
                    Payments
                    <span class="amount">{{ paymentDecorated.paid }}</span>
                  </li>
                  <li class="total" v-if="paymentDecorated.hasSomePayments">
                    Amount Due AUD
                    <span class="amount">{{ paymentDecorated.remaining }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content ibox-content-padding-xs">
            <h3 class="invoice-single">Attached Documents</h3>
            <ul class="file-lists">
              <li v-for="docket of dockets" :key="docket.id">
                <a :href="downloadDocketFileUrl(docket.photo_path)">
                  <i class="fa fa-file-image-o"></i> {{ docket.photo_name }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="margin-20"></div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import { RESET_PAYMENT } from 'vx/mutations'
import { chain, filter } from 'lodash'
import PaymentItem from './ShowPaymentItem'

export default {
  components: {
    PaymentItem
  },

  created () {
    this[RESET_PAYMENT]()

    this.getPaymentByPublicId(this.$route.params.id)
  },

  computed: {
    ...mapGetters('payment', ['paymentDecorated']),
    ...mapState('payment', ['payment']),

    downloadPdfUrl () {
      return `${process.env.API_DOMAIN}/payments/${this.$route.params.id}/public/download`
    },

    items () {
      return chain(this.payment.items)
      .filter({ type: 'load' })
      .each(item => {
        item.charges = filter(this.payment.items, charge => {
          return charge.type !== 'load' && charge.load_id === item.load_id
        })
      })
      .value()
    },

    dockets () {
      let dockets = []

      for (const item of this.items) {
        for (const docket of item.load.weighbridge.dockets) {
          dockets.push(docket)
        }
      }

      return dockets
    }
  },

  methods: {
    ...mapActions('payment', ['getPaymentByPublicId']),
    ...mapMutations('payment', [RESET_PAYMENT]),

    downloadDocketFileUrl (path) {
      return `${process.env.API_DOMAIN}/payments/${this.$route.params.id}/public/${path}/download`
    }
  }
}
</script>

<style scoped>
#page-wrapper {
  margin-left: 0 !important;
}

.payment-logo {
  margin: 0 !important;
  max-width: 250px;
  margin-top: 20px;
}

.xero-number {
  margin-top: 10px !important;
}

.invoice-due.complete {
  margin-top: 28px;
}

.file-lists {
  list-style: none;
  padding-left: 0;
}

.file-lists li {
  margin-bottom: 8px;
}

.file-lists .fa-file-image-o {
  margin-right: 15px;
}
</style>



// WEBPACK FOOTER //
// ShowPublic.vue?44a98922